/** The honorifics a person may carry, in the order a registrar picks from (`ck_lms_person_honorific`). */
export const HONORIFICS = [
  "Sayyid", "Sayyida", "Sayyidah", "Shaykh", "Shaykha", "Dr.", "Prof.",
  "Ustadh", "Ustadha", "Mawlana", "Imam", "Hajj", "Hajja",
  "Mr.", "Mrs.", "Ms.", "Mx.",
] as const;
